import React, { useEffect, useState } from 'react'
import ArticleList from '../components/ArticleList'
import { useInfo } from '../context/useInfo'
import { useLoaderData, useNavigate } from 'react-router';
import IconLinkButton from '../components/inputs/IconLinkButton';
import { generatePlaceholderArrays, getValueFromSettled } from '../utils';

function Home() {
    const { fetchWeb } = useInfo();
    const { promises, data } = useLoaderData<{
        promises?: Promise<PromiseSettledResult<any>[]>,
        data?: PromiseSettledResult<any>[]
    }>();

    const navigate = useNavigate();


    const [articles, setLatestArticles] = useState(data ? getValueFromSettled(data[0]) : null);
    const [tags, setTags] = useState(data ? getValueFromSettled<Record<string, any>[]>(data[1]) : null);

    async function fetchData() {
        if (promises == undefined) return;
        const [promisedArticles, promisedTags] = await promises;
        setLatestArticles(getValueFromSettled(promisedArticles))
        setTags(getValueFromSettled(promisedTags))
    }
    useEffect(() => {
        fetchData()
    });

    async function feelingLucky() {
        const response = await fetchWeb(`/wiki/articles/lucky`)
        if (response && response["article_path"]) {
            navigate(`/${response["article_path"]}`)
        }
    }

    return (
        <section className='flex flex-wrap'>
            <article className='flex-grow'>
                <div >
                    <img src="/images/home.png" alt="home icon" className='w-16 inline mr-2' />
                    <p className='inline align-middle font-semibold text-3xl'>Welcome to the Andec Wiki</p>
                </div>
                <p>Welcome to the Andec Wiki!</p>
            </article>
            <aside className='flex-grow basis-60'>
                <ArticleList
                    label='Latest articles'
                    articles={(articles ? articles : generatePlaceholderArrays(5, { title: "..." })).map(
                        (article: any) => ({ label: article.title, url: article["article_path"] ? `/${article["article_path"]}` : '#' })
                    )}
                />
                <IconLinkButton
                    floating='left'
                    src='/images/spongey.png'
                    label="I'm feeling lucky"
                    onClick={feelingLucky}
                    to='#'
                    className='block w-full mt-4 py-2 px-3 mb-2'
                />
                <ArticleList label='Categories' articles={(tags ? tags : generatePlaceholderArrays(5, { name: "..." })).map(
                    tag => ({ label: tag.name, url: `/tag/${tag.name}` })
                )} />
            </aside>
        </section>
    )
}

export default Home